import {LogLevel, OpenIdConfiguration} from 'angular-auth-oidc-client';
import {inject, Injectable} from '@angular/core';
import {environment} from '../environments/environment';
import {APP_BASE_HREF} from "@angular/common";

@Injectable({providedIn: 'root'})
export class AuthConfigService {

    private readonly baseHref: string = inject(APP_BASE_HREF);

    getConfig(): OpenIdConfiguration {

        return {
            authority:
            environment.authenticationConfiguration.authenticationWellKnownUrl,
            autoUserInfo: false,
            clientId: environment.authenticationConfiguration.clientId,
            historyCleanupOff: true,
            logLevel: LogLevel.Error,
            postLogoutRedirectUri: `${window.location.origin}${this.baseHref}`,
            redirectUrl: `${window.location.origin}${this.baseHref}`,
            responseType: 'code',
            scope: 'openid id.oktaUDID',
            silentRenew: false,
            triggerAuthorizationResultEvent: true,
            useRefreshToken: false,
        };
    }
}
